import { Component, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  arrayAboutUs:any
  arrayAboutDetails:any
  id:any
  load:boolean =false
  arrayAboutAll:any=[]
  selectedItem: any

  constructor(private home : HomeService,private _Activatedroute: ActivatedRoute) {

    this._Activatedroute.paramMap.subscribe(params => {
      this.ngOnInit();
      window.scroll(0, 0);
  });
   }

  ngOnInit(): void {

    this.load = false;
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    if (this.id == null || this.id == '') {
      this.selectedItem = null

        this.home.getPost('getPostDetails', '', 'en', '', 'Home.About', 'NTROOT0', '', '-1').subscribe(data => {
          this.arrayAboutAll = data;
          this.home.getPost('getPost', '', 'en', '', 'Home.About', 'NTROOT0', '', '-1').subscribe(data => {
            this.arrayAboutUs = data
          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
    else
{
  
  this.home.getPost('getPostById', this.id,'en', '', 'Home.About', 'NTROOT0', '', '1').subscribe(data => {
    this.selectedItem = this.id;
    this.arrayAboutAll=data;
    this.home.getPost('getPost', '', 'en', '', 'Home.About', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayAboutUs = data
    setTimeout(() => {
      this.load = true
    }, 2000);
  });
});
          }
    // this.home.getPost('getPost','', 'en', '', 'Home.About', 'NTROOT0', '', '-1').subscribe(data => {
    //   this.arrayAboutUs = data
    //   // this.getAbout(this.id)
    //   this.load = true;
    // })


  }

  // TitleName:string=''
  // NameImg:string = ''
  // aboutSub:string = ''
  // aboutDetails:string = ''
  getAbout(id:string)
  {
    
    this.load = false;
    this.selectedItem = id;
    this.home.getPost('getPostById', id,'en', '', 'Home.About', 'NTROOT0', '', '1').subscribe(data => {
      this.arrayAboutAll=data;
      // let arr = data as any[]
      // this.TitleName = arr[0]['postTitle']
      // this.NameImg = arr[0]['postImage']
      // this.aboutSub = arr[0]['postSubTitle']
      // this.aboutDetails = arr[0]['postDetails']
      // this.home.getPost('getPostById', id,'en', '', 'Home.About', 'NTROOT0', '', '1').subscribe(data => {
      //   this.arrayAboutDetails = data
      this.home.getPost('getPost', '', 'en', '', 'Home.About', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayAboutUs = data
        console.log("AAAA",this.arrayAboutUs)
        this.load = true;
      })
    });
  }




}
